export const SNILS_WARNING_MESSAGE = "Некорректный СНИЛС";

export function validateSnils(raw: string) {
  if (typeof raw !== 'string') {
    return false;
  }

  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 11) {
    return false;
  }

  if (digits === '00000000000') {
    return false;
  }

  const base = digits.slice(0, 9);
  const control = parseInt(digits.slice(9), 10);
  if (!Number.isInteger(control) || control < 0 || control > 99) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(base[i]) * (9 - i);
  }

  let expected: number;
  if (sum < 100) {
    expected = sum;
  } else if (sum === 100 || sum === 101) {
    expected = 0;
  } else {
    expected = sum % 101;
    if (expected === 100) expected = 0;
  }

  return expected === control;
}

export const maskedSnils = (raw: string) => {
  const d = (raw ?? '').replace(/\D/g, '').slice(0, 11);
  return d
    .replace(/^(\d{3})(\d)/, '$1-$2')
    .replace(/^(\d{3})-(\d{3})(\d)/, '$1-$2-$3')
    .replace(/^(\d{3})-(\d{3})-(\d{3})(\d)/, '$1-$2-$3 $4');
};
